var $produktForm = $(".js-produkt_form");

$(function(){
    isSubmitProdukt = false;

    if($produktForm.find(".js-submit").val() == 1){
        formMsgBlockShow($produktForm.find(".js-form_successblock"));
    }

    $produktForm.find(".js-from_submit").on("click", function(event){
        event.preventDefault();

       if(isSubmitProdukt && typeof isSubmitProdukt != "undefined") return false;
        $currentButton = $(this);
        $currentButton.addClass("button_disabled")
        isSubmitProdukt = true;

        var validSubmit = true;
        var errorCount = 0;

        $.each($produktForm.find(".js-form_input"), function(key, value){
            validInput = checkInput($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        $produktForm.find(".js-form_checkbox").each(function(){
            validInput = checkCheckbox($(this))
            if(!validInput){
                validSubmit = false;
                errorCount++;
            }
        });

        if(validSubmit){
            showLoader();

            requestData = "";
            if(typeof $produktForm[0] != "undefined"){
                $produktForm.each(function(index){
                    requestData += "&" + $(this).serialize();
                });
            }

            $.ajax({
                url:$(this).data("ajax"),
                data:requestData,
                type:"POST",
                dataType: "json",
            }).done(function(response){
                $currentButton.removeClass("button_disabled")
                isSubmitProdukt = false;

                if($.isEmptyObject(response.errors)){
                    formMsgBlockShow($produktForm.find(".js-form_successblock"));
                    cartAmountAdd($("#amount").val());
                    if(response.wk_redirect != ""){
                        document.location = response.wk_redirect;
                    }
                }else{
                    var errorCount = 0;
                    $.each(response.errors, function(key, error){
                        if(key == "amount"){
                            var $field = $("[name=" + key + "]");
                            var $label = $field.parents(".form_label").find(".js-form_label");
                            var labelName = $label.data("label");

                            $label.addClass("form_label_text-error").html(labelName + " - " + error);
                        }else{
                            var $field = $("[name=" + key + "]");
                            var $label = $field.siblings(".js-form_label");

                            // Wenn kein spezieller Label-Text angegeben -> Placeholder verwenden
                            var label_text = $field.attr("label_text");

                            $label.addClass("form_label_text-error");
                            $label.text(label_text + " - " + error);
                        }

                        errorCount++;
                    });
                    formMsgBlockShow($produktForm.find(".js-form_errorblock"));
                }
                hideLoader();
            });
        }else{
            $currentButton.removeClass("button_disabled")
            isSubmitProdukt = false;

            formMsgBlockShow($produktForm.find(".js-form_errorblock"));
            hideLoader();
        }
    });
});

if($(".js-produkt").length > 0){

    var $errorBlockProdukt = $(".js-produkt_form").find(".js-form_errorblock");

    produktId = idProdukt;
    ajaxRoot = root;
    ajaxPrice = null;

    $('.js-produkt_gallery').each(function(){ // the containers for all your galleries
        $(this).magnificPopup({
            delegate:'a', // the selector for gallery item
            type:'image',
            gallery:{
                enabled:true,
            }
        });
    });

    $(document).on("change", "#amount", function(e){
        clearTimeout(ajaxPrice);
        ajaxPrice = window.setTimeout(function(){
            updatePrice($("#amount").val());
        }, 1000)
    });

    $(document).on("keydown", "#amount", function(e){
        clearTimeout(ajaxPrice);
        ajaxPrice = window.setTimeout(function(){
            updatePrice($("#amount").val());
        }, 1000)
    });


    updatePrice($("#amount").val());

    function updatePrice(menge){
        $.ajax({
            url:ajaxRoot + "cmshx_template/ajax/ecprod_get_price.php",
            data:{id:produktId,m:menge,
                  csrf_token:csrf_token},
            type:"POST",
            dataType: "json",
        }).done(function(response){
            if(response.val == 1){
                $(".js-produkt_preis").text(response.price + " \u20AC");
                if($(".js-produkt_lagerstand").length > 0) $(".js-produkt_lagerstand").text(response.lager);

            }

            var labelObject = $("#amount").parent().siblings(".js-form_label");
            var labelName = labelObject.data("label");
            if(response.amount != ""){
                $("#amount").data("error", response.amount);
                labelObject.addClass("form_label_text-error").html(labelName + " - " + $("#amount").data("error"));
            }else{
                labelObject.removeClass("form_label_text-error").html(labelName);
            }

        });
    }

    $(document).on("click", ".js-produkt_detail_toggle", function(e){
        e.preventDefault();
        if($(this).hasClass("fa-plus")){
            $(this).removeClass("fa-plus").addClass("fa-minus");
            $(".js-produkt_detail").slideDown(100);
        }else{
            $(this).removeClass("fa-minus").addClass("fa-plus");
            $(".js-produkt_detail").slideUp(100);
        }
    })

    $(document).on("click", ".js-produkt_zusatz_toggle", function(e){
        e.preventDefault();
        if($(this).hasClass("fa-plus")){
            $(this).removeClass("fa-plus").addClass("fa-minus");
            $(".js-produkt_zusatz").slideDown(100);
        }else{
            $(this).removeClass("fa-minus").addClass("fa-plus");
            $(".js-produkt_zusatz").slideUp(100);
        }
    })
}